export default __webpack_public_path__ + "static/media/level-4.e351224a.png";